import { DateTime } from "luxon";

export function morningstarFormDefaults(morningstar) {
  const stored = morningstar || {};
  return {
    "morningstar-rating":
      stored.rating === null || stored.rating === undefined
        ? ""
        : String(stored.rating),
    "morningstar-category": stored.category || "",
    "morningstar-ratingdate": stored.rating_date
      ? DateTime.fromISO(stored.rating_date).toJSDate()
      : null,
  };
}
